import { useUserActiveOrganization } from "@/api";
import { ClientRelease } from "@/features/client-release";
import { Outlet, createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useLocalStorage } from "usehooks-ts";

export const Route = createFileRoute(
  "/_auth/_fixed-sidebar/_organization-access"
)({
  component: Organization
});

function Organization() {
  const navigate = useNavigate();
  const {
    activeOrganization,
    loading: loadingOrganizations,
    error
  } = useUserActiveOrganization();

  const [latestOrganization, setLatestOrganization] = useLocalStorage<
    string | null
  >("latestOrganizationSlug", null);

  // Returns the user to force them to select a valid organization as one could not be found with the current params
  if ((!loadingOrganizations && !activeOrganization) || error) {
    setLatestOrganization(null);
    navigate({ to: "/organization" });
  }

  useEffect(() => {
    if (activeOrganization && latestOrganization !== activeOrganization.slug)
      setLatestOrganization(activeOrganization.slug);
  }, [activeOrganization, latestOrganization, setLatestOrganization]);

  const isLocalHost = window.location.hostname === "localhost";
  return (
    <>
      {!isLocalHost && <ClientRelease />}
      <Outlet />
    </>
  );
}
